import { css } from "@emotion/react";

import { responsiveBreakpoint } from "@constants";

export const rowSNSList = css`
  @media (min-width: ${responsiveBreakpoint[0]}px) {
    margin-bottom: 0px;
    display: flex;
    height: 18px;
  }
`;

export const SNSList = css`
  display: flex;

  > li {
    height: 100%;
    margin-right: 18.4px;
    display: flex;
    align-items: center;
  }

  @media (min-width: ${responsiveBreakpoint[0]}px) {
    > li {
      margin-right: 20px;
    }
  }
`;

export const storeList = css`
  border-left: 1px solid var(--gray-300);
  display: flex;
  padding-left: 20px;

  > li {
    height: 100%;
    margin-right: 18.4px;
    display: flex;
    align-items: center;
  }
`;
